 

export default class Privilege {

    Id: string | undefined;
    Description: string | undefined;
    Speciality: string | undefined;
    
    static NewInstance() {
        return new Privilege();
    }
}